import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const KycDisplay = () => {
  const navigate = useNavigate();
  
  // State for user data
  const [userData, setUserData] = useState({
    aadhar_number: '',
    pan_number: '',
    aadhar_doc: '',
    aadhar_doc2: '',
    pan_doc: '',
    profile_img: '',
    name: '',
    email: '',
    phone: ''
  });
  
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);
  const [userId, setUserId] = useState('');

  // Get user ID from localStorage on component mount
  useEffect(() => {
    const storedUserId = localStorage.getItem('userid');
    if (storedUserId) {
      setUserId(storedUserId);
      fetchUserData(storedUserId);
    } else {
      toast.error('User ID not found. Please login again.');
      setLoading(false);
      setFetchError(true);
    }
  }, []);

  // Function to fetch user data from API
  const fetchUserData = async (id) => {
  //  alert(id)
    try {
      setLoading(true);
      const url = `https://octafxx.in/Rest/user_details_api/${id}`;
  const response = await fetch(url);
  
  if (!response.ok) {
    throw new Error(`Server responded with status: ${response.status}`);
  }
  
  const responseData = await response.json();
  console.log(responseData);
      // Assuming the API returns data in a specific structure
      // You may need to adjust this based on actual API response
     // if (responseData.status==0) {
        // Map API response to our state structure
        setUserData({
          aadhar_number: responseData.aadhar || 'Not provided',
          pan_number: responseData.pan_no || 'Not provided',
          aadhar_doc: responseData.aadhar_doc || '',
          aadhar_doc2: responseData.aadhar_doc2 || '',
          pan_doc: responseData.pan_doc || '',
          profile_img: responseData.profile_img || '',
          name: responseData.first_name || 'Not available',
          email: responseData.email || 'Not available',
          phone: responseData.mobile || 'Not available'
        });
        toast.success('User data loaded successfully');
      
    } catch (error) {
      console.error('Error fetching user data:', error);
      toast.error('Failed to load user data. Please try again later.');
      setFetchError(true);
      
      // For demo purposes - showing sample data when API fails
      // Remove this in production
      setUserData({
        aadhar_number: 'XXXX XXXX 1234',
        pan_number: 'ABCDE1234F',
        aadhar_doc: 'https://example.com/aadhar_front.jpg',
        aadhar_doc2: 'https://example.com/aadhar_back.jpg',
        pan_doc: 'https://example.com/pan_card.jpg',
        profile_img: 'https://example.com/selfie.jpg',
        name: 'John Doe',
        email: 'john@example.com',
        phone: '+91 9876543210'
      });
    } finally {
      setLoading(false);
    }
  };

  // Function to render document image
  const renderDocumentImage = (title, imageUrl, docType) => {
    const placeholder = `https://via.placeholder.com/300x200/1a5276/ffffff?text=${encodeURIComponent(title)}`;
    
    return (
      <div className="col-md-6 mb-4">
        <div className="card h-100 border border-light shadow-sm">
          <div className="card-body text-center">
            <h6 className="card-title fw-bold text-dark mb-3">{title}</h6>
            
            {imageUrl ? (
              <div className="d-flex flex-column h-100">
                <div className="flex-grow-1 d-flex align-items-center justify-content-center mb-3">
                  <img
                    src={imageUrl}
                    alt={title}
                    className="img-fluid rounded border"
                    style={{ 
                      maxHeight: '150px', 
                      objectFit: 'cover',
                      width: '100%'
                    }}
                    onError={(e) => {
                      e.target.src = placeholder;
                    }}
                  />
                </div>
                <div>
                  <span className="badge bg-success">Verified ✓</span>
                  <p className="text-muted small mt-2 mb-0">{docType} Document</p>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column h-100 justify-content-center align-items-center p-3">
                <div className="mb-3">
                  <i className="bi bi-image text-secondary fs-1"></i>
                </div>
                <h6 className="card-title fw-bold text-dark mb-2">No {title} Available</h6>
                <p className="text-muted small mb-0">Document not uploaded</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Function to render user info card
  const renderUserInfo = (label, value, icon) => (
    <div className="col-md-4 mb-3">
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <div className="d-flex align-items-center mb-2">
            <i className={`bi bi-${icon} text-primary me-2`}></i>
            <h6 className="card-subtitle text-muted mb-0">{label}</h6>
          </div>
          <p className="card-text fw-bold fs-5">{value}</p>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="container-fluid p-0 min-vh-100 bg-light d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 fw-semibold">Loading KYC information...</p>
        </div>
      </div>
    );
  }

  if (fetchError && !userId) {
    return (
      <div className="container-fluid p-0 min-vh-100 bg-light d-flex justify-content-center align-items-center">
        <div className="text-center">
          <i className="bi bi-exclamation-triangle text-danger fs-1 mb-3"></i>
          <h3 className="mb-3">User ID Not Found</h3>
          <p className="text-muted mb-4">Please login to view your KYC information</p>
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/login')}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0 min-vh-100 bg-light">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Header */}
    

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            {/* User Information Card */}
            <div className="card shadow-lg border-0 rounded-4 mb-4">
              <div className="card-body p-4 p-md-5">
                <div className="text-center mb-5">
                  <h2 className="fw-bold text-primary mb-3">Your KYC Details</h2>
                  <p className="text-muted">Verified user information and documents</p>
                </div>

                {/* User ID Display */}
                <div className="alert alert-info mb-4">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-person-badge me-3 fs-4"></i>
                    <div>
                      <h6 className="alert-heading mb-1">User Identification</h6>
                      <p className="mb-0">User ID: <strong>{userId}</strong></p>
                    </div>
                  </div>
                </div>

                {/* Personal Information */}
                <div className="mb-5">
                  <h4 className="fw-bold text-dark mb-4 border-bottom pb-2">
                    <i className="bi bi-person-circle me-2"></i>
                    Personal Information
                  </h4>
                  <div className="row">
                    {renderUserInfo('Full Name', userData.name, 'person')}
                    {renderUserInfo('Email Address', userData.email, 'envelope')}
                    {renderUserInfo('Phone Number', userData.phone, 'telephone')}
                  </div>
                </div>

                {/* Document Information */}
                <div className="mb-5">
                  <h4 className="fw-bold text-dark mb-4 border-bottom pb-2">
                    <i className="bi bi-card-checklist me-2"></i>
                    Document Details
                  </h4>
                  
                  {/* Aadhar Information */}
                  <div className="mb-4">
                    <h5 className="fw-semibold mb-3 text-dark">
                      <i className="bi bi-card-text me-2"></i>
                      Aadhar Information
                    </h5>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <div className="card border-light shadow-sm">
                          <div className="card-body">
                            <h6 className="card-subtitle text-muted mb-2">Aadhar Number</h6>
                            <p className="card-text fw-bold fs-4">{userData.aadhar_number}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card border-light shadow-sm">
                          <div className="card-body">
                            <h6 className="card-subtitle text-muted mb-2">Verification Status</h6>
                            <span className="badge bg-success fs-6">
                              <i className="bi bi-check-circle me-1"></i>
                              Verified
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Aadhar Images */}
                    <div className="row g-3">
                      {renderDocumentImage('Aadhar Front', userData.aadhar_doc, 'Aadhar')}
                      {renderDocumentImage('Aadhar Back', userData.aadhar_doc2, 'Aadhar')}
                    </div>
                  </div>

                  {/* PAN Information */}
                  <div className="mb-4">
                    <h5 className="fw-semibold mb-3 text-dark">
                      <i className="bi bi-credit-card me-2"></i>
                      PAN Information
                    </h5>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <div className="card border-light shadow-sm">
                          <div className="card-body">
                            <h6 className="card-subtitle text-muted mb-2">PAN Number</h6>
                            <p className="card-text fw-bold fs-4">{userData.pan_number}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card border-light shadow-sm">
                          <div className="card-body">
                            <h6 className="card-subtitle text-muted mb-2">Verification Status</h6>
                            <span className="badge bg-success fs-6">
                              <i className="bi bi-check-circle me-1"></i>
                              Verified
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* PAN Images */}
                    <div className="row g-3">
                      {renderDocumentImage('PAN Card', userData.pan_doc, 'PAN')}
                      {renderDocumentImage('Selfie', userData.profile_img, 'Profile')}
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="d-grid gap-3">
                  <button
                    className="btn btn-outline-primary btn-lg py-3"
                    onClick={() => navigate('/home')}
                  >
                    <i className="bi bi-house me-2"></i>
                    Back to Home
                  </button>
                  
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      localStorage.removeItem('userid');
                      navigate('/login');
                    }}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Logout
                  </button>
                </div>
              </div>
            </div>

            {/* Verification Status */}
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-shield-check text-success fs-3 me-3"></i>
                  <div>
                    <h5 className="fw-bold mb-1">KYC Verification Complete</h5>
                    <p className="text-muted mb-0">All documents have been verified successfully</p>
                  </div>
                </div>
                
                <div className="row text-center mt-4">
                  <div className="col-3">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center bg-success text-white mb-2" 
                         style={{ width: '50px', height: '50px' }}>
                      <i className="bi bi-check-lg fs-5"></i>
                    </div>
                    <div className="small fw-bold">Identity</div>
                  </div>
                  <div className="col-3">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center bg-success text-white mb-2" 
                         style={{ width: '50px', height: '50px' }}>
                      <i className="bi bi-check-lg fs-5"></i>
                    </div>
                    <div className="small fw-bold">Address</div>
                  </div>
                  <div className="col-3">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center bg-success text-white mb-2" 
                         style={{ width: '50px', height: '50px' }}>
                      <i className="bi bi-check-lg fs-5"></i>
                    </div>
                    <div className="small fw-bold">PAN</div>
                  </div>
                  <div className="col-3">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center bg-success text-white mb-2" 
                         style={{ width: '50px', height: '50px' }}>
                      <i className="bi bi-check-lg fs-5"></i>
                    </div>
                    <div className="small fw-bold">Selfie</div>
                  </div>
                </div>
                
                <div className="alert alert-success mt-4">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-info-circle me-3 fs-5"></i>
                    <div>
                      <h6 className="alert-heading mb-2">Verification Status: Active</h6>
                      <p className="mb-0">Your KYC verification was completed successfully. All documents are verified and up to date.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycDisplay;